import { render, staticRenderFns } from "./TheSubcategory.vue?vue&type=template&id=6434d552&scoped=true"
import script from "./TheSubcategory.vue?vue&type=script&lang=ts"
export * from "./TheSubcategory.vue?vue&type=script&lang=ts"
import style0 from "./TheSubcategory.vue?vue&type=style&index=0&id=6434d552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6434d552",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreSearchFiltersTheAlert: require('/usr/src/nuxt-app/components/core/search/filters/TheAlert.vue').default})
